<template>
  <div class="popup z-index-10-fg confirmation small-popup send-email-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Email {{ emailTemplates[templateId].name }}</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('close')" />
      </div>
      <div class="popup-body">
        <p>A new email window will open. Once you've sent the email, click 'Confirm Sent' to record it. An interaction will be created for this lead automatically.</p>
      </div>
      <div class="popup-footer">
        <button @click="$emit('close')" class="text-btn">Did not send</button>
        <button @click="confirmSent" :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }">Confirm Sent<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useEmail from '../composables/useEmail';
import useInteractionMutate from '../composables/useInteractionMutate';
import useCurrentUser from '../composables/useCurrentUser';
import useAlerts from '../composables/useAlerts';

export default {
  name: 'SendEmail',
  emits: ['close'],
  props: {
    templateId: {
      type: String,
      required: true,
    },
    lead: {
      type: Object,
      required: true,
    },
    selectedContractors: {
      type: Array,
      required: false,
    },
  },
  setup() {
    const { emailTemplates, sendEmail } = useEmail();
    const { addInteraction } = useInteractionMutate();
    const { user } = useCurrentUser();
    const { addAlert } = useAlerts();

    return {
      emailTemplates,
      sendEmail,
      addInteraction,
      user,
      addAlert,
    };
  },
  data() {
    return {
      isSaving: false,
    };
  },
  mounted() {
    const address = this.lead.contact?.email?.ADDRESS || this.lead?.email?.ADDRESS;
    const name = this.lead.contact ? this.lead.contact?.FIRSTNAME : this.lead?.NAME;

    this.sendEmail({
      email: address,
      name,
      templateName: this.templateId,
      selectedContractors: this.selectedContractors,
    });
  },
  methods: {
    async confirmSent() {
      this.isSaving = true;

      let note = `Sent ${this.emailTemplates[this.templateId].name}`;
      if (this.templateId === 'contractorList' && this.selectedContractors?.length > 0) {
        note += ` with ${this.selectedContractors.length} contractor${this.selectedContractors.length === 1 ? '' : 's'}`;
      }

      const success = await this.addInteraction({
        LEADID: this.lead.LEADID,
        SALESPERSONID: this.user.userid,
        DATE: new Date().getTime().toString(),
        TYPE: 'Email Sent',
        NOTE: note,
      });

      if (success) {
        this.addAlert('Email sent and interaction created', 'low', 3);
      }

      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.send-email-popup {
  width: 28rem;

  .popup-content {
    padding: 0;
  }
}
</style>
